import { memo } from 'react'
import styles from './styles.module.css'
import { classNames, useMediaQuery } from '@monorepo/utils'
import { getCommonAssetPath } from '../../geo/config'
import { useGeoRuntime } from '../../geo/useGeoRuntime'
import { renderDecorElements, renderMainElement } from './renderElements'
const DecorateElements = () => {
  const { geo, geoConfig } = useGeoRuntime()
  const { isDesktop, isLandscape, isTabletPortrait } = useMediaQuery()
  const isDesktopLandscape = isDesktop && isLandscape

  const device = isDesktop ? 'desktop' : isTabletPortrait || isLandscape ? 'tablet' : 'mobile'
  const decorElements = geoConfig.layout.decorElements?.[device]
  return (
    <>
      <div className={classNames(styles.headerGradient, styles.abs)} />
      <div className={classNames(styles.footerGradient, styles.abs)} />
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet={getCommonAssetPath(geoConfig.layout.background.desktopFile)}
        />
        <img
          src={getCommonAssetPath(
            geoConfig.layout.background.mobileFile || geoConfig.layout.background.desktopFile,
          )}
          alt={geoConfig.layout.background.alt}
          className={classNames(styles[geoConfig.layout.background.className], styles.abs)}
          fetchPriority={geoConfig.layout.background.fetchPriority}
        />
      </picture>
      {/* Decor Elements */}
      {decorElements && renderDecorElements(decorElements)}

      {/* Main Elements */}
      {renderMainElement(geoConfig.layout.payment, geo, isDesktopLandscape, isTabletPortrait, isLandscape)}
      {renderMainElement(geoConfig.layout.girl, geo, isDesktopLandscape, isTabletPortrait, isLandscape)}
    </>
  )
}
export default memo(DecorateElements)
